import { getCategories, getContents, rateContents, searchCatalog } from "../../api/catalog";
import { toObject } from "../../utils/languageContent";

const setting = {
    namespaced: true,
    state: {
        content: [],
        isContentLastChild: false,
    },
    mutations: {
        SET_CATEGORY: (state, payload) => {
            state.content = payload;
            state.isContentLastChild = false;
        },
        SET_CHILDREN: (state, payload) => {
            state.content = payload;
        },
        SET_IS_LAST_CHILD: (state, payload) => {
            state.isContentLastChild = payload;
        },
    },
    actions: {
        getCategories({ commit }) {
            return getCategories().then((response) => {
                commit(
                    "SET_CATEGORY",
                    response.data.map((x) => toObject(x))
                );
            });
        },
        getChildren({ commit }, payload) {
            return getContents(payload).then((response) => {
                commit(
                    "SET_CHILDREN",
                    response.data.map((x) => toObject(x))
                );
            });
        },
        rateContent(_, payload) {
            return rateContents(payload);
        },
        setContent({ commit }, payload) {
            let content = [payload];
            commit("SET_CHILDREN", content);
        },
        setIsLastChild({ commit }, payload) {
            commit("SET_IS_LAST_CHILD", payload);
        },
        searchCatalog({}, { query, lang }) {
            return searchCatalog(query, lang);
        },
    },
};

export default setting;



// WEBPACK FOOTER //
// ./src/store/modules/catalog.js